class FpfNavigationSearch extends HTMLElement {
  connectedCallback() {
    if (this.input) return;
    this.input = this.querySelector('input[type="search"]');
    this.panel = this.querySelector('.fpf-navigation-suggestions');
    this.results = this.querySelector('.fpf-navigation-suggestions__results');
    this.all = this.querySelector('.fpf-navigation-suggestions__all');
    this.status = this.querySelector('[data-search-status]');
    this.events = new AbortController();
    this.index = -1;
    const options = { signal: this.events.signal };
    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);
      this.request?.abort();
      this.close();
      const term = this.input.value.trim();
      if (term) this.timer = setTimeout(() => this.suggest(term), 200);
      else this.status.textContent = '';
    }, options);
    this.input.addEventListener('focus', () => {
      if (this.loadedTerm === this.input.value.trim() && this.results.textContent.trim()) this.open();
    }, options);
    this.input.addEventListener('keydown', event => this.navigate(event), options);
    this.addEventListener('focusout', () => {
      queueMicrotask(() => { if (!this.contains(document.activeElement)) this.close(); });
    }, options);
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target)) this.close();
    }, options);
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.request?.abort();
    this.events?.abort();
    this.input = null;
  }
  async suggest(term) {
    const request = new AbortController();
    this.request = request;
    this.status.textContent = this.status.dataset.loading;
    const url = new URL(this.dataset.endpoint, location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('section_id', this.dataset.section);
    try {
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error('Search request failed');
      const html = await response.text();
      if (request.signal.aborted || term !== this.input.value.trim()) return;
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fpf-product-results]');
      if (!content) throw new Error('Search results missing');
      this.results.replaceChildren(...content.childNodes);
      this.items = [...this.results.querySelectorAll('[role="option"]')];
      this.items.forEach((item, index) => { item.id = this.panel.id + '-option-' + index; });
      const allUrl = new URL(this.querySelector('form').action);
      allUrl.searchParams.set('q', term);
      allUrl.searchParams.set('options[prefix]', 'last');
      this.all.href = allUrl.href;
      this.loadedTerm = term;
      this.status.textContent = this.results.querySelector('[data-result-announcement]')?.textContent || '';
      if (document.activeElement === this.input) this.open();
    } catch (error) {
      if (error.name !== 'AbortError') { this.close(); this.status.textContent = ''; }
    }
  }
  open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
  close() {
    this.panel.hidden = true;
    this.index = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
    this.items?.forEach(item => item.setAttribute('aria-selected', 'false'));
  }
  navigate(event) {
    if (event.key === 'Escape') {
      if (!this.panel.hidden) { event.preventDefault(); event.stopPropagation(); }
      clearTimeout(this.timer);
      this.request?.abort();
      this.close();
      return;
    }
    if (event.key === 'Enter' && !this.panel.hidden && this.index >= 0) {
      event.preventDefault();
      this.items[this.index].querySelector('a').click();
      return;
    }
    if (!['ArrowDown', 'ArrowUp'].includes(event.key) || !this.items?.length || this.loadedTerm !== this.input.value.trim()) return;
    event.preventDefault();
    this.open();
    this.index = this.index < 0 ? (event.key === 'ArrowDown' ? 0 : this.items.length - 1) : (this.index + (event.key === 'ArrowDown' ? 1 : this.items.length - 1)) % this.items.length;
    this.items.forEach((item, index) => item.setAttribute('aria-selected', String(index === this.index)));
    this.input.setAttribute('aria-activedescendant', this.items[this.index].id);
    this.items[this.index].scrollIntoView({ block: 'nearest' });
  }
}
if (!customElements.get('fpf-navigation-search')) customElements.define('fpf-navigation-search', FpfNavigationSearch);
